import { DELEGATION_STATES } from 'common/domain/constants';

class DelegationsListController {
  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
  }

  $onInit() {
    if (this.isMobileApp) {
      this.floatingActionButtons = this.initFloatingActionButtons();
    }
  }

  openModal() {
    this.openDelegationModal(this.EventEmitter({ action: DELEGATION_STATES.CREATE }));
  }

  cancel({ delegation }) {
    this.openDelegationModal(this.EventEmitter({ action: DELEGATION_STATES.CANCEL, delegation: delegation }));
  }

  edit({ delegation }) {
    this.openDelegationModal(this.EventEmitter({ action: DELEGATION_STATES.EDIT, delegation: delegation }));
  }

  isEmpty() {
    if (!this.delegations) return true;
    return !this.delegations.length;
  }

  initFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.CREATE_DELEGATION'
      }
    ];
  }
}

export default DelegationsListController;



// WEBPACK FOOTER //
// ./client/app/components/delegationsList/delegationsList.controller.js